export class NewItemsCount {
    constructor(
        public numberOfEmployeesAdvances?: number,
        public numberOfEmployeesCostsToAccept?: number,
        public numberOfEmployeesCostsToService?: number,
        public numberOfUserAdvances?: number,
        public numberOfUserCostsInProgress?: number,
        public numberOfUserRejectedCosts?: number,
    ) { }

    static adapt(item: any): NewItemsCount {
        return new NewItemsCount(
            item.numberOfEmployeesAdvances,
            item.numberOfEmployeesCostsToAccept,
            item.numberOfEmployeesCostsToService,
            item.numberOfUserAdvances,
            item.numberOfUserCostsInProgress,
            item.numberOfUserRejectedCosts,
        );
    }
}

